import React from 'react';
import { useField } from 'formik';

const CheckBox = ({ children, ...props }) => {
	// We need to tell useField what type of input this is
	// since React treats radios and checkboxes differently
	// than inputs/select/textarea.
	const [field, meta] = useField({ ...props, type: 'checkbox' });
	let missing = meta.touched && meta.error ? ' missing ' : null;
	return (
		<>
			<label className={props.className + ' ' + missing }>

				<input type="checkbox" {...field} {...props} />
				{children}
			</label>			
		</>
	);
};

export default CheckBox;